namespace TabAurous.Production {
    export interface QualityInspectionItemsRow {
        TransItemId?: number;
        TransId?: number;
        ProductId?: number;
        AttributeId?: number;
        BagNo?: string;
        DepartmentId?: number;
        ProcessId?: number;
        WorkerId?: number;
        RefTransId?: number;
        RefTransItemId?: number;
        RefVoucherId?: number;
        EmployeeName?: string;
        ProcessName?: string;
        TransDate?: string;
        RefVoucherNo?: string;
        ProductCode?: string;
        DeptName?: string;
        Status?: string;
        Values?: QualityInspectionValuesRow[];
    }

    export namespace QualityInspectionItemsRow {
        export const idProperty = 'TransItemId';
        export const nameProperty = 'BagNo';
        export const localTextPrefix = 'Production.QualityInspectionItems';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            TransItemId = "TransItemId",
            TransId = "TransId",
            ProductId = "ProductId",
            AttributeId = "AttributeId",
            BagNo = "BagNo",
            DepartmentId = "DepartmentId",
            ProcessId = "ProcessId",
            WorkerId = "WorkerId",
            RefTransId = "RefTransId",
            RefTransItemId = "RefTransItemId",
            RefVoucherId = "RefVoucherId",
            EmployeeName = "EmployeeName",
            ProcessName = "ProcessName",
            TransDate = "TransDate",
            RefVoucherNo = "RefVoucherNo",
            ProductCode = "ProductCode",
            DeptName = "DeptName",
            Status = "Status",
            Values = "Values"
        }
    }
}
